import axios from "axios";

const updateAdditionalInfoSequence = (info) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`/serialnumber/api/v1/additional-info/sequence/update`, {
        info,
      })
      .then((response) => resolve(response.data))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

export default updateAdditionalInfoSequence;
